type PersonLike = Readonly<{ firstName?: string | null; lastName?: string | null }>;

export const getPersonName = (person: PersonLike): string => [person.firstName, person.lastName].filter(Boolean).join(' ') || '—';

export const getAvatarInitials = (person: PersonLike): string => {
  const first = person.firstName?.charAt(0) ?? '';
  const last = person.lastName?.charAt(0) ?? '';
  return (first + last).toUpperCase() || '?';
};
